var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _vm.tb != "1"
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      disabled: _vm.readonly,
                      inputLabel: _vm.$t("common.routing.config_name"),
                      placeholderValue: _vm.$t("common.routing.config_name"),
                    },
                    model: {
                      value: _vm.name,
                      callback: function ($$v) {
                        _vm.name = $$v
                      },
                      expression: "name",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tb != "1"
            ? _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "active" } }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("common.routing.active"))
                  ),
                  _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.active,
                        expression: "active",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      disabled: _vm.readonly,
                      id: "active",
                      "aria-label": _vm.$t("common.routing.active"),
                    },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.active = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "1" } }, [
                      _vm._v(" " + _vm._s(_vm.$t("common.routing.yes")) + " "),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "0", selected: "" } }, [
                      _vm._v(" " + _vm._s(_vm.$t("common.routing.no")) + " "),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.host"),
                  placeholderValue: _vm.$t("common.routing.host"),
                },
                model: {
                  value: _vm.host,
                  callback: function ($$v) {
                    _vm.host = $$v
                  },
                  expression: "host",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.port"),
                  placeholderValue: _vm.$t("common.routing.port"),
                },
                model: {
                  value: _vm.port,
                  callback: function ($$v) {
                    _vm.port = $$v
                  },
                  expression: "port",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  disabled: _vm.readonly,
                  isMandatory: _vm.tb == "1",
                  maxLength: 512,
                  inputLabel: _vm.$t("common.routing.uri"),
                  placeholderValue: _vm.$t("common.routing.uri"),
                },
                model: {
                  value: _vm.uri,
                  callback: function ($$v) {
                    _vm.uri = $$v
                  },
                  expression: "uri",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.tb != "1"
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      maxLength: 512,
                      inputLabel: _vm.$t("common.routing.timeout"),
                      placeholderValue: _vm.$t("common.routing.timeout"),
                    },
                    model: {
                      value: _vm.timeout,
                      callback: function ($$v) {
                        _vm.timeout = $$v
                      },
                      expression: "timeout",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tb != "1"
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      maxLength: 512,
                      inputLabel: _vm.$t("common.routing.connect_timeout"),
                      placeholderValue: _vm.$t(
                        "common.routing.connect_timeout"
                      ),
                    },
                    model: {
                      value: _vm.connectTimeout,
                      callback: function ($$v) {
                        _vm.connectTimeout = $$v
                      },
                      expression: "connectTimeout",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.formatName != "" && _vm.formatOutName != "" && _vm.tb != "1"
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      disabled: "",
                      inputLabel: _vm.$t("common.routing.format_name"),
                      placeholderValue: _vm.$t("common.routing.format_name"),
                    },
                    model: {
                      value: _vm.formatName,
                      callback: function ($$v) {
                        _vm.formatName = $$v
                      },
                      expression: "formatName",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.formatName != "" && _vm.formatOutName != "" && _vm.tb != "1"
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      disabled: "",
                      inputLabel: _vm.$t("common.routing.format_out_name"),
                      placeholderValue: _vm.$t(
                        "common.routing.format_out_name"
                      ),
                    },
                    model: {
                      value: _vm.formatOutName,
                      callback: function ($$v) {
                        _vm.formatOutName = $$v
                      },
                      expression: "formatOutName",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tb != "1"
            ? _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "ssl-active" } }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("common.routing.ssl_active"))
                  ),
                  _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.sslActive,
                        expression: "sslActive",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { disabled: _vm.readonly, id: "ssl-active" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.sslActive = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "1" } }, [
                      _vm._v(" " + _vm._s(_vm.$t("common.routing.yes")) + " "),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "0", selected: "" } }, [
                      _vm._v(" " + _vm._s(_vm.$t("common.routing.no")) + " "),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.sslActive != "0" && _vm.tb != "1"
            ? _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "keystore" } }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("common.routing.keystore"))
                  ),
                  _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.keystore,
                        expression: "keystore",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { disabled: _vm.readonly, id: "keystore" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.keystore = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.keystoreList, function (keystore) {
                    return _c(
                      "option",
                      { key: keystore.id, domProps: { value: keystore.id } },
                      [_vm._v(" " + _vm._s(keystore.name) + " ")]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.sslActive != "0" && _vm.tb != "1"
            ? _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "ca" } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("common.routing.certificat")) +
                      "\n"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.ca,
                        expression: "ca",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { disabled: _vm.readonly, id: "ca" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.ca = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.caList, function (ca) {
                    return _c(
                      "option",
                      { key: ca.id, domProps: { value: ca.id } },
                      [_vm._v(" " + _vm._s(ca.name) + " ")]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.tb == "1" ? _c("b-col", { attrs: { sm: "6" } }) : _vm._e(),
          _vm._v(" "),
          _vm.tb == "1"
            ? _c(
                "b-col",
                { staticClass: "form-group mt-3", attrs: { sm: "6" } },
                [
                  _c("span", [
                    _c("span", { staticClass: "filter-item-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("certificates.details_certificate"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "color-red" }, [_vm._v("* ")]),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm.CertificateInput
                    ? _c(
                        "b-col",
                        { staticClass: "form-group mt-3", attrs: { sm: "12" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _vm.CertificateInput.deliveredTo !== ""
                                    ? _c("form-read-group-label-input", {
                                        attrs: {
                                          inputLabel: _vm.$t(
                                            "certificates.common_name"
                                          ),
                                          inputValue:
                                            _vm.CertificateInput.deliveredTo,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _vm.CertificateInput.deliveredBy !== ""
                                    ? _c("form-read-group-label-input", {
                                        attrs: {
                                          inputLabel: _vm.$t(
                                            "certificates.issued_by"
                                          ),
                                          inputValue:
                                            _vm.CertificateInput.deliveredBy,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _vm.CertificateInput.startDate !== ""
                                    ? _c("form-read-group-label-input", {
                                        attrs: {
                                          inputLabel: _vm.$t(
                                            "certificates.valid_from"
                                          ),
                                          inputValue:
                                            _vm.CertificateInput.startDate,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _vm.CertificateInput.endDate !== ""
                                    ? _c("form-read-group-label-input", {
                                        attrs: {
                                          inputLabel: _vm.$t(
                                            "certificates.valid_until"
                                          ),
                                          inputValue:
                                            _vm.CertificateInput.endDate,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tb == "1"
            ? _c(
                "b-col",
                {
                  staticClass: "form-group d-flex flex-column mt-3",
                  attrs: { sm: "6" },
                },
                [
                  _vm.CAServer
                    ? _c(
                        "div",
                        { staticClass: "certificate-details" },
                        [
                          _c("span", [
                            _c("span", { staticClass: "filter-item-title" }, [
                              _vm._v(
                                _vm._s(_vm.$t("certificates.details_ca_server"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "color-red" }, [
                              _vm._v("* "),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.CertificatServerParsed
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "certificate-details mt-3 pl-0",
                                  attrs: { sm: "12" },
                                },
                                [
                                  _c(
                                    "b-row",
                                    { staticClass: "ml-0" },
                                    [
                                      _c(
                                        "b-col",
                                        { staticClass: "pl-0" },
                                        [
                                          _vm.CertificatServerParsed
                                            .deliveredTo !== ""
                                            ? _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "certificates.common_name"
                                                    ),
                                                    inputValue:
                                                      _vm.CertificatServerParsed
                                                        .deliveredTo,
                                                  },
                                                }
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _vm.CertificatServerParsed
                                            .deliveredBy !== ""
                                            ? _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "certificates.issued_by"
                                                    ),
                                                    inputValue:
                                                      _vm.CertificatServerParsed
                                                        .deliveredBy,
                                                  },
                                                }
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _vm.CertificatServerParsed
                                            .startDate !== ""
                                            ? _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "certificates.valid_from"
                                                    ),
                                                    inputValue:
                                                      _vm.CertificatServerParsed
                                                        .startDate,
                                                  },
                                                }
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _vm.CertificatServerParsed.endDate !==
                                          ""
                                            ? _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "certificates.valid_until"
                                                    ),
                                                    inputValue:
                                                      _vm.CertificatServerParsed
                                                        .endDate,
                                                  },
                                                }
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.CAServer
                            ? _c(
                                "b-col",
                                { staticClass: "p-0", attrs: { sm: "12" } },
                                [
                                  _c("details", { staticClass: "mt-4" }, [
                                    _c(
                                      "summary",
                                      {
                                        staticClass:
                                          "w-50 btn btn-primary d-inline-block px-3 py-2 rounded",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "certificates.view_ca_certificates"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "pre",
                                      {
                                        staticClass:
                                          "p-2 bg-light text-monospace",
                                      },
                                      [_vm._v(_vm._s(_vm.CAServer))]
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tb == "1"
            ? _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } })
            : _vm._e(),
          _vm._v(" "),
          _c("b-col", { staticClass: "my-2", attrs: { sm: "6" } }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.login && _vm.password && _vm.tb != "1"
        ? _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("common.token_credentials"),
                isTitleUpperCase: false,
              },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "fake-hr-right px-0", attrs: { cols: "6" } },
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "form-write-group-label-input",
                            {
                              attrs: {
                                disabled: true,
                                maxLength: 512,
                                inputType: "select",
                                inputLabel: _vm.$t(
                                  "common.routing.loginStorage"
                                ),
                              },
                              model: {
                                value: _vm.loginStorage,
                                callback: function ($$v) {
                                  _vm.loginStorage = $$v
                                },
                                expression: "loginStorage",
                              },
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.loginStorage,
                                      expression: "loginStorage",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { disabled: true },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.loginStorage = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("common.routing.volume_select")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "PEM" } }, [
                                    _vm._v(_vm._s("PEM")),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "FILE" } }, [
                                    _vm._v(_vm._s("Volume")),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "Vault" } }, [
                                    _vm._v(_vm._s("Vault")),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "8" } },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      disabled: true,
                                      maxLength: 512,
                                      inputLabel: _vm.$t(
                                        "common.routing.loginFile"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "common.routing.loginFile"
                                      ),
                                    },
                                    model: {
                                      value: _vm.loginFile,
                                      callback: function ($$v) {
                                        _vm.loginFile = $$v
                                      },
                                      expression: "loginFile",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "login-file-type" } },
                                    [_vm._v(_vm._s(_vm.$t("common.variable")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-radio-group",
                                    {
                                      attrs: {
                                        disabled: true,
                                        id: "login-file-type",
                                      },
                                      model: {
                                        value: _vm.loginFileType,
                                        callback: function ($$v) {
                                          _vm.loginFileType = $$v
                                        },
                                        expression: "loginFileType",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "variableP12PwdInsideFile-radio",
                                            value: "ENV",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("common.env")))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "variableP12PwdInsideFile-radio",
                                            value: "OTHER",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("common.other")))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "8" } },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      disabled: true,
                                      maxLength: 512,
                                      inputLabel: _vm.$t(
                                        "common.routing.loginYAML"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "common.routing.loginYAML"
                                      ),
                                    },
                                    model: {
                                      value: _vm.loginYAML,
                                      callback: function ($$v) {
                                        _vm.loginYAML = $$v
                                      },
                                      expression: "loginYAML",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "login-yaml-type" } },
                                    [_vm._v(_vm._s(_vm.$t("common.variable")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-radio-group",
                                    {
                                      attrs: {
                                        disabled: true,
                                        id: "login-yaml-type",
                                      },
                                      model: {
                                        value: _vm.loginYAMLType,
                                        callback: function ($$v) {
                                          _vm.loginYAMLType = $$v
                                        },
                                        expression: "loginYAMLType",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "variableP12PwdInsideFile-radio",
                                            value: "ENV",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("common.env")))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "variableP12PwdInsideFile-radio",
                                            value: "OTHER",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("common.other")))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "px-0", attrs: { cols: "6" } },
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "form-write-group-label-input",
                            {
                              attrs: {
                                disabled: true,
                                maxLength: 512,
                                inputType: "select",
                                inputLabel: _vm.$t(
                                  "common.routing.passwordStorage"
                                ),
                              },
                              model: {
                                value: _vm.passwordStorage,
                                callback: function ($$v) {
                                  _vm.passwordStorage = $$v
                                },
                                expression: "passwordStorage",
                              },
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.loginStorage,
                                      expression: "loginStorage",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { disabled: true },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.loginStorage = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("common.routing.volume_select")
                                      ) + "..."
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "PEM" } }, [
                                    _vm._v(_vm._s("PEM")),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "FILE" } }, [
                                    _vm._v(_vm._s("Volume")),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "Vault" } }, [
                                    _vm._v(_vm._s("Vault")),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "8" } },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      disabled: true,
                                      maxLength: 512,
                                      inputLabel: _vm.$t(
                                        "common.routing.passwordFile"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "common.routing.passwordFile"
                                      ),
                                    },
                                    model: {
                                      value: _vm.passwordFile,
                                      callback: function ($$v) {
                                        _vm.passwordFile = $$v
                                      },
                                      expression: "passwordFile",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "pwd-file-type" } },
                                    [_vm._v(_vm._s(_vm.$t("common.variable")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-radio-group",
                                    {
                                      attrs: {
                                        disabled: true,
                                        id: "pwd-file-type",
                                      },
                                      model: {
                                        value: _vm.passwordFileType,
                                        callback: function ($$v) {
                                          _vm.passwordFileType = $$v
                                        },
                                        expression: "passwordFileType",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "variableP12PwdInsideFile-radio",
                                            value: "ENV",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("common.env")))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "variableP12PwdInsideFile-radio",
                                            value: "OTHER",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("common.other")))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "8" } },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      disabled: true,
                                      maxLength: 512,
                                      inputLabel: _vm.$t(
                                        "common.routing.passwordYAML"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "common.routing.passwordYAML"
                                      ),
                                    },
                                    model: {
                                      value: _vm.passwordYAML,
                                      callback: function ($$v) {
                                        _vm.passwordYAML = $$v
                                      },
                                      expression: "passwordYAML",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "pwd-yaml-type" } },
                                    [_vm._v(_vm._s(_vm.$t("common.variable")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-radio-group",
                                    {
                                      attrs: {
                                        disabled: true,
                                        id: "pwd-yaml-type",
                                      },
                                      model: {
                                        value: _vm.passwordYAMLType,
                                        callback: function ($$v) {
                                          _vm.passwordYAMLType = $$v
                                        },
                                        expression: "passwordYAMLType",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "variableP12PwdInsideFile-radio",
                                            value: "ENV",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("common.env")))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            name: "variableP12PwdInsideFile-radio",
                                            value: "OTHER",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("common.other")))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.sslActive === "1" && _vm.tb != "1"
        ? _c("level-control-form", {
            attrs: {
              mode: _vm.mode,
              readonly: _vm.readonly,
              placementLevel: _vm.placementWebService,
            },
            model: {
              value: _vm.controlConfig,
              callback: function ($$v) {
                _vm.controlConfig = $$v
              },
              expression: "controlConfig",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.tb != "1"
        ? _c(
            "form-accordion",
            {
              attrs: { title: _vm.$t("common.proxy"), isTitleUpperCase: false },
            },
            [
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("label", { attrs: { for: "proxy-active" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("common.routing.proxy_active"))
                        ),
                        _c("span", { staticClass: "color-red" }, [
                          _vm._v(" * "),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.proxyActive,
                              expression: "proxyActive",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { disabled: _vm.readonly, id: "proxy-active" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.proxyActive = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "1" } }, [
                            _vm._v(
                              " " + _vm._s(_vm.$t("common.routing.yes")) + " "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "option",
                            { attrs: { value: "0", selected: "" } },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("common.routing.no")) + " "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("b-col", {
                    staticClass: "form-group",
                    attrs: { sm: "6" },
                  }),
                  _vm._v(" "),
                  _vm.proxyActive == "1"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              disabled: _vm.readonly,
                              maxLength: 512,
                              inputLabel: _vm.$t("common.routing.proxy_host"),
                              placeholderValue: _vm.$t(
                                "common.routing.proxy_host"
                              ),
                            },
                            model: {
                              value: _vm.proxyHost,
                              callback: function ($$v) {
                                _vm.proxyHost = $$v
                              },
                              expression: "proxyHost",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.proxyActive == "1"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              disabled: _vm.readonly,
                              maxLength: 512,
                              inputLabel: _vm.$t("common.routing.proxy_port"),
                              placeholderValue: _vm.$t(
                                "common.routing.proxy_port"
                              ),
                            },
                            model: {
                              value: _vm.proxyPort,
                              callback: function ($$v) {
                                _vm.proxyPort = $$v
                              },
                              expression: "proxyPort",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.proxyActive == "1"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              disabled: _vm.readonly,
                              maxLength: 512,
                              inputLabel: _vm.$t("common.routing.proxy_login"),
                              placeholderValue: _vm.$t(
                                "common.routing.proxy_login"
                              ),
                            },
                            model: {
                              value: _vm.proxyLogin,
                              callback: function ($$v) {
                                _vm.proxyLogin = $$v
                              },
                              expression: "proxyLogin",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.proxyActive == "1"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              disabled: _vm.readonly,
                              maxLength: 512,
                              inputLabel: _vm.$t("common.routing.proxy_pwd"),
                              placeholderValue: _vm.$t(
                                "common.routing.proxy_pwd"
                              ),
                            },
                            model: {
                              value: _vm.proxyPwd,
                              callback: function ($$v) {
                                _vm.proxyPwd = $$v
                              },
                              expression: "proxyPwd",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.proxyActive == "1"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("label", { attrs: { for: "proxy-tunnel" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("common.routing.proxy_tunnel"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("b-form-checkbox", {
                            attrs: {
                              id: "proxy-tunnel",
                              disabled: _vm.readonly,
                              value: 1,
                              "unchecked-value": 0,
                            },
                            model: {
                              value: _vm.proxyTunnel,
                              callback: function ($$v) {
                                _vm.proxyTunnel = $$v
                              },
                              expression: "proxyTunnel",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.proxyActive == "1"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c(
                            "label",
                            { attrs: { for: "proxy-connect-only" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("common.routing.proxy_connect_only")
                                )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("b-form-checkbox", {
                            attrs: {
                              id: "proxy-connect-only",
                              value: 1,
                              "unchecked-value": 0,
                              disabled: _vm.readonly,
                            },
                            model: {
                              value: _vm.proxyConnectOnly,
                              callback: function ($$v) {
                                _vm.proxyConnectOnly = $$v
                              },
                              expression: "proxyConnectOnly",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.entitiesType === "rvm" && _vm.tb != "1"
        ? _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("common.vop_provider.vop_provider"),
                isTitleUpperCase: false,
              },
            },
            [
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("label", { attrs: { for: "vopProvider" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("common.vop_provider.name")) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.IdVopProvider,
                              expression: "IdVopProvider",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { disabled: _vm.readonly, id: "vopProvider" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.IdVopProvider = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            { attrs: { value: "", hidden: "", disabled: "" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "common.routing.select_name_vop_provider"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.vopProviderList, function (vopProvider) {
                            return _c(
                              "option",
                              {
                                key: vopProvider.id,
                                domProps: { value: vopProvider.id },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(vopProvider.text) +
                                    "\n            "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }